
// 调用旧协议
function kkhybrid_coupon_list(opt) {
    hybrid({
        hybridParam: {
            schema: 'kkhybrid',
            tagname: 'couponList'
        },
        callback: function (res) {
            opt.callback && opt.callback(res);
        }
    });
}

// 调用新协议
function kkmhhybrid_coupon_list(opt) {
    hybrid({
        hybridParam: {
            schema: 'kkmhhybrid',
            tagname: 'get_coupon_list'
        },
        callback: function (res) {
            opt.callback && opt.callback(res);
        }
    });
}

/**
 * 获取优惠券列表信息
 * @param {Object} opt 参数对象
 * @param {Function} opt.callback 回调函数
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置）
 */
function get_coupon_list (opt = {}, criticalAppVersion) {
    var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion)
    if (allow) {
        kkmhhybrid_coupon_list(opt);
    } else {
        kkhybrid_coupon_list(opt);
    }
}

export default get_coupon_list;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/get_coupon_list/index.js